import React from 'react';

import { StarAiFill } from '@lyearn/icons';
import { css } from '@lyearn/style';
import { Button, Input, Popover, PopoverContentPosition, Stack, Typography } from '@lyearn/ui';

const blackBorderInput = css`
  & .MuiOutlinedInput-notchedOutline {
    border-color: black !important;
  }
  &:hover .MuiOutlinedInput-notchedOutline,
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: black !important;
  }
  & .MuiInputBase-root {
    background-color: var(--bg-bg-secondary);
  }
`;

function GenerateScriptWindow({
  children,
  defaultOpen = false,
  isLoading,
  onClick,
  position = 'left-start',
}: {
  children: React.ReactNode;
  defaultOpen?: boolean;
  isLoading?: boolean;
  onClick: (userPrompt: string) => void;
  position?: PopoverContentPosition;
}) {
  const [value, setValue] = React.useState('');
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(defaultOpen);

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <Popover.Button>{children}</Popover.Button>
      <Popover.Content position={position}>
        <Stack className="w-[28.3rem] p-16" direction="col" gap={16}>
          <Typography variant="heading-xxs">Custom Prompt</Typography>
          <Input
            autoFocus
            multiline
            className={blackBorderInput}
            inputProps={{ className: 'bg-bg-secondary' }}
            placeholder="Write a custom prompt to guide Lyearn AI. For example, you can ask for a specific tone, style, or format."
            rows={4}
            value={value}
            onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              setValue(event.target.value)
            }
          />
          <Button
            className="w-full !rounded-full"
            endIcon={<StarAiFill height={16} width={16} />}
            loading={isLoading}
            onClick={() => {
              onClick(value.trim());
              setValue('');
              setIsPopoverOpen(false);
            }}>
            Generate script
          </Button>
        </Stack>
      </Popover.Content>
    </Popover>
  );
}

export default GenerateScriptWindow;
